import React from 'react';
import PhoneInput from 'react-phone-number-input/input';
import * as PhoneInputStyles from 'react-phone-number-input/style.css';
import { isValidPhoneNumber } from 'react-phone-number-input';
import withStyles from 'isomorphic-style-loader/withStyles';
import { BaseTextField } from '../TextField';

const PhoneInputRef = React.forwardRef((props, ref) => (
  <BaseTextField
    inputRef={ref}
    fullWidth
    id="phone"
    type="text"
    key="phone"
    name="phone"
    variant="outlined"
    {...props}
  />
));

const getPhoneError = (value: string) => {
  if (!value) {
    return 'Phone number required';
  }

  try {
    if (isValidPhoneNumber(value)) {
      return undefined;
    }
  } catch (ex) {
    console.error('Phone validation error', ex);
  }

  return 'Invalid phone number';
};

interface PhoneNumberInputProps {
  value: string;
  touched?: boolean;
  onChange: (value: string) => void;
  onBlur: () => void;
  sizeVariant?: 'skinny' | 'medium' | 'tall';
}

const PhoneNumberInput: React.FC<PhoneNumberInputProps> = ({
  value,
  touched,
  onChange,
  onBlur,
  sizeVariant = 'skinny',
  ...other
}) => {
  const errorMessage = getPhoneError(value);
  return (
    <PhoneInput
      defaultCountry="US"
      onChange={onChange}
      value={value}
      onBlur={onBlur}
      error={Boolean(touched && errorMessage)}
      helperText={(touched && getPhoneError(value)) || ' '}
      sizeVariant={sizeVariant}
      inputComponent={PhoneInputRef}
      {...other}
    />
  );
};

export default withStyles(PhoneInputStyles)(PhoneNumberInput);
